// Don't remove, else BigInt won't work
/* global BigInt */

import { message, Modal, Button } from "antd";
import axios from 'axios';

import { allocateGhostFeesPayment } from '.';

// checks 
// a) that metamask is installed, 
// b) that the user is on ethereu mmainnet
// c) checks the co9nnected wallet's address is equal to ethusdc_address
export const checkMetaMaskAndNetwork = async (ethusdc_address) => {
  // Ensure MetaMask is installed
  if (typeof window.ethereum === "undefined") {
    console.error("MetaMask is not installed.");
    return { success: false, error: "MetaMask is not installed." };
  }

  try {
    // Check current network
    const chainId = await window.ethereum.request({ method: "eth_chainId" });

    if (chainId !== "0x1") {
      console.log("Not on Ethereum mainnet. Attempting to switch...");
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x1" }],
        });
        console.log("Switched to Ethereum mainnet.");
      } catch (switchError) {
        if (switchError.code === 4902) {
          return { success: false, error: "Ethereum mainnet is not available in the version of MetaMask installed on your computer." };
        }
        return { success: false, error: "Failed to switch to Ethereum mainnet." };
      }
    }

    // Request account access
    const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });

    if (accounts.length === 0) {
      return { success: false, error: "No Ethereum account found." };
    }

    const walletAddress = accounts[0];

    // Check if the wallet address matches ethusdc_address
    if (walletAddress.toLowerCase() === ethusdc_address.toLowerCase()) {
      console.log("Connected to the correct Ethereum address.");
      return { success: true, address: walletAddress };
    } else {
      console.error("Connected wallet does not match ethusdc_address.");
      return { success: false, error: "Connected wallet does not match the ethusdc_address in our database. You must sign into Metamask again, and please ensure the Metamask account you sign in with is the correct one." };
      // UPDATE ERROR ABOVE
    }

  } catch (error) {
    console.error("Error checking MetaMask and network:", error);
    return { success: false, error: "An error occurred while checking MetaMask and network." };
  }
};

// TODO: handle metamask error when payment is cancelled from metamask payment dialog
export const metamaskSendUSDC = async (toAddress, fromAddress, amount) => {
  // Use Ant Design message to show warning
  const warningKey = 'transaction-warning';
  const warningMessage = message.loading({
    content: 'Transaction in progress. Do not navigate away from Punkypay.com - doing so may result in errors.',
    key: warningKey,
    duration: 0, // Don't auto-dismiss
    style: {
      marginTop: '50px', // To ensure visibility
    }
  });

  // Create modal for back button attempts
  const warningModal = Modal.warning({
    title: 'Confirm Transaction within 15 Minutes',
    content: 'Fluctuating fees on the Ethereum network may delay transaction if not confirmed soon.',
    maskClosable: false,
    closable: false,
    visible: false, // Start hidden
    footer: <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
      <Button key="stay" type="primary" onClick={() => {
        warningModal.destroy();
      }}>
        Stay on Page
      </Button>
    </div>
    // footer: [
    // <button key="stay" type="primary" onClick={() => warningModal.destroy()}>
    //     Stay on Page
    // </button>
    // ]
  });

  // Add event listener for beforeunload (closing tab/browser)
  const beforeUnloadListener = (e) => {
    e.preventDefault();
    // Standard way of showing a confirmation message in most browsers
    e.returnValue = 'Transaction in progress! If you leave now, your transaction may still process but you won\'t be able to track it here.';
    return e.returnValue;
  };
  window.addEventListener('beforeunload', beforeUnloadListener);

  // Also prevent going back with browser history
  const preventNavigation = (e) => {
    e.preventDefault();
    warningModal.update({ visible: true }); // Show modal when user tries to go back
    // Stay on current page
    return false;
  };
  window.history.pushState(null, null, window.location.href);
  window.addEventListener('popstate', preventNavigation);

  try {
    // Ensure MetaMask is installed
    if (typeof window.ethereum === "undefined") {
      throw new Error("MetaMask is not installed.");
    }

    // Request account access and get the current account
    await window.ethereum.request({ method: "eth_requestAccounts" });
    const accounts = await window.ethereum.request({ method: "eth_accounts" });
    const walletAddress = accounts[0];

    if (walletAddress !== fromAddress) {
      throw new Error("The wallet saved in Punkypay does not match this Metamask account's wallet. Please sign in again.");
    }

    // ✅ USDC Contract Address on Ethereum Mainnet
    const USDC_CONTRACT_ADDRESS = "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eb48";

    // ✅ USDC Transfer ABI
    const usdcTransferABI = [
      {
        "constant": false,
        "inputs": [
          { "name": "to", "type": "address" },
          { "name": "value", "type": "uint256" }
        ],
        "name": "transfer",
        "outputs": [{ "name": "", "type": "bool" }],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
      }
    ];

    // ✅ Calculate amount in smallest unit (USDC has 6 decimals)
    const decimals = 6;
    const usdcAmount = BigInt(amount * 10 ** decimals).toString(16);

    // ✅ Encode the transaction data for the `transfer` function
    const methodId = "a9059cbb"; // Keccak-256 of "transfer(address,uint256)" first 4 bytes
    const paddedToAddress = toAddress.replace("0x", "").padStart(64, "0");
    const paddedAmount = usdcAmount.padStart(64, "0");
    const data = `0x${methodId}${paddedToAddress}${paddedAmount}`;

    // ✅ Estimate Gas with buffer (For USDC contract call)
    const rawGasEstimate = await window.ethereum.request({
      method: "eth_estimateGas",
      params: [{
        from: fromAddress,
        to: USDC_CONTRACT_ADDRESS,
        data: data,
      }]
    });

    // Add buffer to gas estimate (20%)/(1.2)
    const gasBuffer = 1.25;
    const gasEstimateInt = parseInt(rawGasEstimate, 16);
    const bufferedGasEstimate = Math.floor(gasEstimateInt * gasBuffer);
    const gasEstimate = '0x' + bufferedGasEstimate.toString(16);

    // // ✅ Get Current Gas Price with buffer
    // let gasPrice = await window.ethereum.request({ method: "eth_gasPrice" });

    // // Add buffer to gas price (20%)/(1.2)
    // const gasPriceBuffer = 2;
    // const gasPriceInt = parseInt(gasPrice, 16);
    // const bufferedGasPrice = Math.floor(gasPriceInt * gasPriceBuffer);
    // const finalGasPrice = '0x' + bufferedGasPrice.toString(16);

    // ===========================================
    // EIP-1559 fee estimation
    // ===========================================

    // Get recommended priority fee from the node
    let suggestedPriorityFee;

    try {
      suggestedPriorityFee = await window.ethereum.request({
        method: "eth_maxPriorityFeePerGas"
      });
    } catch {
      // fallback if RPC doesn't support the method
      suggestedPriorityFee = "0x77359400"; // 2 gwei
    }

    // Get current block
    const latestBlock = await window.ethereum.request({
      method: "eth_getBlockByNumber",
      params: ["latest", false]
    });

    const currentBaseFee = parseInt(
      latestBlock.baseFeePerGas,
      16
    );

    const priorityFeeInt = parseInt(
      suggestedPriorityFee,
      16
    );

    // Conservative buffers
    const priorityFeeBuffer = 1.25;
    const baseFeeBuffer = 1.5;

    // Double the suggested tip
    const maxPriorityFeePerGas = Math.floor(
      priorityFeeInt * priorityFeeBuffer
    );

    // Double the current base fee
    const maxFeePerGas =
      Math.floor(currentBaseFee * baseFeeBuffer) +
      maxPriorityFeePerGas;

    const finalMaxPriorityFeePerGas =
      "0x" + maxPriorityFeePerGas.toString(16);

    const finalMaxFeePerGas =
      "0x" + maxFeePerGas.toString(16);

    // ✅ Check ETH balance (for gas fees)
    const balance = await window.ethereum.request({
      method: "eth_getBalance",
      params: [walletAddress, "latest"]
    });

    const balanceInEth = BigInt(balance);
    // Updated for EIP-1559
    // const gasCost = BigInt(parseInt(gasEstimate, 16)) * BigInt(parseInt(finalGasPrice, 16));
    const gasCost = BigInt(parseInt(gasEstimate, 16)) * BigInt(maxFeePerGas);

    // Convert Wei to ETH
    const weiToEth = (wei) => Number(wei) / 1e18;
    const ethCost = weiToEth(gasCost);
    const ethBalance = weiToEth(balanceInEth);

    if (balanceInEth < gasCost) {
      throw new Error(`Not enough ETH to cover gas fees. 
            Required: ${ethCost.toFixed(6)} ETH. 
            Your Balance: ${ethBalance.toFixed(6)} ETH.`);
    }

    // ✅ Send Transaction (to USDC contract, NOT recipient)
    // Updated per EIP-1559
    // const txHash = await window.ethereum.request({
    //   method: "eth_sendTransaction",
    //   params: [{
    //     from: fromAddress,
    //     to: USDC_CONTRACT_ADDRESS,
    //     data: data,
    //     gas: gasEstimate,
    //     gasPrice: finalGasPrice
    //   }]
    // });
    const txHash = await window.ethereum.request({
      method: "eth_sendTransaction",
      params: [{
        from: fromAddress,
        to: USDC_CONTRACT_ADDRESS,
        data: data,
        gas: gasEstimate,
        maxPriorityFeePerGas:
          finalMaxPriorityFeePerGas,
        maxFeePerGas:
          finalMaxFeePerGas
      }]
    });

    console.log("Transaction sent! Tx Hash:", txHash);

    const fetchEthToUsdcRate = async () => {
      try {
        const response = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd");
        const data = await response.json();
        return data.ethereum.usd;  // Returns the ETH to USD rate
      } catch (error) {
        console.error("Error fetching ETH to USDC rate:", error);
        return 2000;  // Default rate if the API call fails
      }
    };

    const convertEthToUsdc = async (ethCost) => {
      const ethToUsdcRate = await fetchEthToUsdcRate();
      const usdcCost = ethCost * ethToUsdcRate;
      console.log("Gas cost in USDC:", usdcCost);

      return usdcCost;
    };

    // Inside your metamaskSendUSDC function
    const usdcCost = await convertEthToUsdc(ethCost);  // Convert gas cost to USDC
    console.log("Gas cost in USDC:", usdcCost);

    // Clean up warning elements and event listeners after transaction is sent
    message.success({ content: 'Transaction submitted successfully!', key: warningKey, duration: 2 });
    warningModal.destroy();
    window.removeEventListener('beforeunload', beforeUnloadListener);
    window.removeEventListener('popstate', preventNavigation);

    // console.log(txHash);  // returns 0x0e3e071d7494b8d62ff3e093eb76831ca2c3d575328695fbbc7b7a13ae884497
    // console.log(gasEstimate); // returns the gas estimate with buffer
    // console.log(finalGasPrice); // returns the gas price with buffer
    // console.log(ethCost);  // returns gas cost in ETH
    // console.log(usdcCost); // returns gas cost in USDC

    // Return both the transaction hash and the gas info as an object
    return {
      txHash,
      gasInfo: {
        gasEstimate: gasEstimate,
        // gasPrice: finalGasPrice, //Updaed per EIP-1559
        maxPriorityFeePerGas: finalMaxPriorityFeePerGas, //Updaed per EIP-1559
        maxFeePerGas: finalMaxFeePerGas, //Updaed per EIP-1559
        estimatedCostETH: ethCost,
        estimatedCostUSDC: usdcCost
      }
    };

  } catch (error) {
    // Clean up warning elements and event listeners on error
    message.error({ content: error.message, key: warningKey, duration: 2 });
    warningModal.destroy();
    window.removeEventListener('beforeunload', beforeUnloadListener);
    window.removeEventListener('popstate', preventNavigation);

    // setLoading(false); // Stop loading on error

    // if (error.code === 4001) {
    // setError("Transaction rejected by the user.");
    // console.error("User denied transaction signature.");
    // // Return error information
    // return {
    //     error: true,
    //     message: "Transaction rejected by the user."
    // };
    // } else {
    // setError(error.message);
    // console.error("Error in SendUSDC function, likely due to Metamask or CoinGecko API:", error.message);
    // // Return error information
    // return {
    //     error: true,
    //     message: error.message
    // };
    // }

    throw error;
  }
};

// ORIGINAL VERSION
export const getPendingTransactionStatusMetamask = async (txHash) => {
  let status = 'pending';
  
  try {
    const receipt = await window.ethereum.request({
      method: "eth_getTransactionReceipt",
      params: [txHash],
    });

    if (receipt) {
      if(receipt.status === "0x1") status = 'completed';
      if(receipt.status === "0x0") status = 'failed';
    }
  } catch (err) {
    // just log the error. Don't throw
    console.error("RPC error:", err);
  }

  return { status };
}


// THIS IS WHERE I PUT CODE I GRABBED AND AM ADAPTING...CAN DELETE LATER
// export const getPendingTransactionStatusMetamask = async (txHash) => {
//   let status = "pending";
//   try {
//     const receipt = await window.ethereum.request({
//       method: "eth_getTransactionReceipt",
//       params: [txHash],
//     });

//     if (!receipt) {
//       return { status };
//     }

//     // Transaction failed according to MetaMask
//     if (receipt.status === "0x0") {
//       return {
//         status: "failed",
//       };
//     }

//     // MetaMask says success -> ask server to verify
//     if (receipt.status === "0x1") {
//       try {
//         const response = await axios.post(
//           "/api/alchemy/verify-alchemy-receipt",
//           {
//             txHash,
//           }
//         );

//         status = response.data.status;
//       } catch (err) {
//         console.error("Server verification failed:", err);

//         // Don't complete if we couldn't even reach the server.
//         // Leave pending so it can be retried later.
//         status = "pending";
//       }
//     }
//   } catch (err) {
//     console.error("RPC error:", err);
//   }

//   return { status };
// };

// THE FOLLOWING STUFF GOES ON MY SERVER

// const { ethers } = require("ethers");

// const provider = new ethers.JsonRpcProvider(
//     `https://eth-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`
// );

// router.post("/verify-metamask-receipt", async (req, res) => {
//     const { txHash } = req.body;

//     try {
//         const receipt = await provider.send(
//             "eth_getTransactionReceipt",
//             [txHash]
//         );

//         // Still pending
//         if (!receipt) {
//             return res.json({
//                 status: "pending",
//             });
//         }

//         // Independent node confirms success
//         if (receipt.status === "0x1") {
//             return res.json({
//                 status: "completed",
//             });
//         }

//         // Independent node reports failed.
//         // Per your requirements, DO NOT change the status.
//         if (receipt.status === "0x0") {
//             return res.json({
//                 status: "pending",
//             });
//         }

//         return res.json({
//             status: "pending",
//         });

//     } catch (err) {
//         console.error(err);

//         // RPC/API error (rate limit, timeout, provider outage, etc.)
//         // Per your requirements, still trust MetaMask's success.
//         return res.json({
//             status: "completed",
//         });
//     }
// });

// this sends payment to Punkypay since is a single payment for when amount is equal or less tha ghost fee owed
export const handleOnlyGhostFeePaymentForMetamask = async (
  sentFrom, formValue, senderEmail, transactionsAndFees, punkypayPaymentAddress, punkypayPaymentEmail
) => {
  if (!punkypayPaymentAddress || !punkypayPaymentEmail) {
    throw new Error('punkypayPaymentAddress and punkypayPaymentEmail are required to process this transaction');
  }

  const amount = formValue.amount;

  console.log('amount ====>', amount);
  const responseSendUSDC = await metamaskSendUSDC(punkypayPaymentAddress, sentFrom, amount);
  const ghostFeeDetails = {};

  // const allocatedTransactions = allocateGhostFeesPayment(unpaidGhostFees.transactionsAndFees, amount);
  const allocatedTransactions = allocateGhostFeesPayment(transactionsAndFees, amount);
  ghostFeeDetails.transactionsAndFees = allocatedTransactions;

  console.log('ghostFeeDetails ------->', ghostFeeDetails)
  console.log(responseSendUSDC.txHash);
  console.log(responseSendUSDC.gasInfo.estimatedCostUSDC);
  const sendCryptoData = {
    // accountId: account.id, // I dont think I need this for metamask? or I should use the crypto address? I think this is supposed to be the ethusdc_account identifier?
    // accessToken: storage.getItem(Coinbase_Auth_Token), //I won't need this
    to: formValue.recipient.toLowerCase().trim(),
    from: senderEmail, //loginEmail, 
    amount,
    currency: "USDC",
    network_name: 'ethereum', // This should be different based on the variable we put in at the top of this function
    txn_id: responseSendUSDC.txHash,
    gas_cost: responseSendUSDC.gasInfo.estimatedCostUSDC.toString(),
    shortMemo: formValue.shortMemo,
    notes: formValue.notes,
    isTransactionFee: true,
    ghostFeeDetails,
    totalAmountUserEntered: formValue.amount,
    splitPaymentStatus: 'no',
    transactionFeePaymentEmail: punkypayPaymentEmail
    // twoFactorToken: twoFactorRequire ? value?.twoFactorToken : null, // do not need this
  };

  return axios.post('/api/transactions/send-crypto-metamask', sendCryptoData);
}

export const handleTransactionSplitPaymentForMetamask = async (
  {
    sentTo,
    sentFrom,
    unpaidGhostFees,
    formValue,
    senderEmail,
    isTransactionFee = false,
    transactionFeeId,
    punkypayPaymentAddress,
    punkypayPaymentEmail,
    handleSuccess,
    handleError
  }
) => {
  try {
    if (isTransactionFee && (!punkypayPaymentAddress || !punkypayPaymentEmail)) {
      throw new Error('punkypayPaymentAddress and punkypayPaymentEmail are required to process transaction fee');
    }

    const amount = isTransactionFee && unpaidGhostFees?.total ? unpaidGhostFees.total : (Number(formValue.amount) * 1000000 - Number(unpaidGhostFees?.total || 0) * 1000000) / 1000000;

    console.log('amount ====>', amount);
    const responseSendUSDC = await metamaskSendUSDC(
      isTransactionFee ? punkypayPaymentAddress : sentTo, sentFrom, amount
    );
    const ghostFeeDetails = {};

    if (
      isTransactionFee &&
      unpaidGhostFees?.transactionsAndFees?.length &&
      amount >= unpaidGhostFees?.total
    ) {
      ghostFeeDetails.transactionsAndFees = unpaidGhostFees.transactionsAndFees.map((txsAndFees) => {
        return {
          ...txsAndFees,
          ghost_fee_punkypay_payment_status: 'yes',
          ghost_fee_punkypay_balance: 0,
        }
      })
    }

    const sendCryptoData = {
      // accountId: account.id, // I dont think I need this for metamask? or I should use the crypto address? I think this is supposed to be the ethusdc_account identifier?
      // accessToken: storage.getItem(Coinbase_Auth_Token), //I won't need this
      to: formValue.recipient.toLowerCase().trim(),
      from: senderEmail,
      amount,
      currency: "USDC",
      network_name: 'ethereum', // This should be different based on the variable we put in at the top of this function
      txn_id: responseSendUSDC.txHash,
      gas_cost: responseSendUSDC.gasInfo.estimatedCostUSDC.toString(),
      shortMemo: formValue.shortMemo,
      notes: formValue.notes,
      isTransactionFee,
      transactionFeeId, // Note this can be undefined. used only to link TransactionFee with its parent Transaction if provided.
      ghostFeeDetails,
      totalAmountUserEntered: formValue.amount,
      splitPaymentStatus: isTransactionFee ? 'pending' : 'completed',
      transactionFeePaymentEmail: isTransactionFee ? punkypayPaymentEmail : undefined
    };

    const responseSaveInDatabase = await axios.post('/api/transactions/send-crypto-metamask', sendCryptoData);

    if (responseSaveInDatabase) {
      console.log('Transaction Created successfully ---=>', responseSaveInDatabase.data);
      if (isTransactionFee) {
        // Open second transaction confirmation modal
        Modal.confirm({
          title: 'Second Payment!',
          content: `The second payment of $${(Number(formValue.amount) * 1000000 - Number(unpaidGhostFees?.total || 0) * 1000000) / 1000000
            } will be paid to ${formValue.recipient.toLowerCase().trim()}`,
          maskClosable: false,
          closable: false,
          visible: false, // Start hidden
          okText: 'Continue',
          onOk: () => {
            handleTransactionSplitPaymentForMetamask(
              {
                sentTo,
                sentFrom,
                unpaidGhostFees,
                formValue,
                senderEmail,
                isTransactionFee: false,
                transactionFeeId: responseSaveInDatabase.data._id,
                punkypayPaymentAddress,
                punkypayPaymentEmail,
                handleSuccess,
                handleError
              }

            );
          },
          cancelButtonProps: { style: { display: 'none' } } //This removes the cancel button
        });
      } else {
        if (handleSuccess && typeof handleSuccess === 'function') {
          handleSuccess(responseSaveInDatabase);
        }
      }
    }
  } catch (error) {
    if (handleError && typeof handleError === 'function') {
      handleError(error);
    }
  }
}
